import React from 'react';
import { PageLayout } from '../shared/PageLayout';
import { GovernanceOverviewTab } from '../../../governance/tabs/GovernanceOverviewTab';
export function QualityStatsPage() {
  return <PageLayout title="Kwaliteitsstatistieken" subtitle="Voer de governance-pipeline uit en bekijk kwaliteitsscores per module" breadcrumbs={[{
    label: 'Content & Kwaliteit'
  }, {
    label: 'Kwaliteitsstatistieken'
  }]} data-id="element-87">
      <GovernanceOverviewTab data-id="element-88" />
    </PageLayout>;
}